import { format, isValid, parseISO } from 'date-fns'
import { IconType } from 'react-icons'
import { FiAlertTriangle, FiCheckCircle, FiClock } from 'react-icons/fi'

export type PurchaseScheduleStatus = 'emAtraso' | 'pendente' | 'noPrazo'

// Mesma regra do statusCounts do provider: emAtraso > pendencia > noPrazo
export const getRowStatus = (row: {
  emAtraso?: boolean
  pendencia?: boolean
}): PurchaseScheduleStatus =>
  row.emAtraso ? 'emAtraso' : row.pendencia ? 'pendente' : 'noPrazo'

export const STATUS_CONFIG: Record<
  PurchaseScheduleStatus,
  { label: string; color: string; icon: IconType }
> = {
  emAtraso: { label: 'Em Atraso', color: 'red', icon: FiAlertTriangle },
  pendente: { label: 'Pendente', color: 'yellow', icon: FiClock },
  noPrazo: { label: 'No Prazo', color: 'green', icon: FiCheckCircle }
}

// Datas do backend vêm em ISO; parseISO interpreta sem fuso como horário local
export const parseDate = (value?: string | null): Date | null => {
  if (!value) return null
  const date = parseISO(value)
  return isValid(date) ? date : null
}

export const formatDateBR = (
  value?: string | null,
  pattern = 'dd/MM/yyyy',
  fallback = '-'
): string => {
  const date = parseDate(value)
  return date ? format(date, pattern) : fallback
}

// Chave do dia no fuso local (não usar toISOString, que converte para UTC)
export const toDayKey = (date: Date): string => format(date, 'yyyy-MM-dd')

// Percentual com 1 casa decimal
export const toPercentage = (value: number, total: number): number =>
  total > 0 ? Math.round((value / total) * 1000) / 10 : 0

export const formatPercentage = (value: number): string =>
  `${value.toLocaleString('pt-BR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  })}%`

export const pluralize = (count: number, singular: string, plural: string) =>
  `${count.toLocaleString('pt-BR')} ${count === 1 ? singular : plural}`
